import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Exploreindiapancab() {



  const cardData =
  {
    keyword: 'Explore  Pan India Cab Booking Services ',
    heading: 'Shambhu Cabs: Explore  Pan India Cab Booking Services',
    headingDescription: 'Shambhu Cabs offers reliable Pan India Cab Booking Services, providing safe, comfortable, and hassle-free travel across cities and states for families, corporate travelers, business groups, and long-distance commuters. Our fleet of hatchbacks, sedans, SUVs, luxury cars, and tempo travellers ensures smooth and convenient journeys for intercity travel, airport transfers, corporate trips, and leisure tours. With professional chauffeurs, flexible one-way and round-trip options, doorstep pickup from your location, and 24/7 booking support, Shambhu Cabs makes Pan India travel seamless, stress-free, and enjoyable. Whether it’s a weekend getaway, business travel, pilgrimage, or holiday trip, Shambhu Cabs delivers trusted and comfortable Pan India cab booking services designed for reliability, safety, and a memorable travel experience.',

    top: 'Top Places to Visit in India with Shambhu Cabs',

 
"topPlaces": [
  {
    "title": "Taj Mahal, Agra",
    "description": "The Taj Mahal, built in the 17th century by Mughal Emperor Shah Jahan, is India’s most iconic monument of love. Constructed entirely from white marble, it features intricate carvings, symmetrical gardens, and a reflecting pool that enhances its grandeur. A UNESCO World Heritage Site, it attracts millions of tourists annually who come to admire its architectural brilliance, historical significance, and serene ambiance."
  },
  {
    "title": "Jaipur City Palace, Rajasthan",
    "description": "The City Palace in Jaipur showcases a blend of Rajasthani and Mughal architecture. It houses museums, courtyards, and royal residences, reflecting the grandeur of the Jaipur royal family. Visitors explore intricately carved gates, balconies, and halls decorated with paintings and artifacts. The palace is a vibrant cultural and historical landmark, offering insight into Rajasthan’s royal heritage."
  },
  {
    "title": "Kerala Backwaters",
    "description": "The Kerala Backwaters are a network of interconnected canals, rivers, lakes, and lagoons in southern India. Tourists enjoy houseboat cruises, lush landscapes, coconut groves, and traditional village life. The calm waters and abundant wildlife provide a serene experience, making it one of India’s most tranquil natural attractions."
  },
  {
    "title": "Varanasi Ghats, Uttar Pradesh",
    "description": "Varanasi, one of the oldest living cities in the world, is renowned for its ghats along the Ganges River. Visitors witness morning rituals, boat rides, and evening aarti ceremonies. The ghats are central to Hindu spiritual practices, making Varanasi a major pilgrimage site and cultural hub, rich in history and religious traditions."
  },
  {
    "title": "Mysore Palace, Karnataka",
    "description": "Mysore Palace, the royal residence of the Wodeyar dynasty, is famous for its Indo-Saracenic architecture, intricate carvings, and dazzling illumination during festivals. Tourists can explore grand halls, expansive courtyards, and museum sections displaying royal artifacts. The palace is especially vibrant during the annual Dussehra festival, showcasing Karnataka’s cultural heritage."
  },
  {
    "title": "Golden Temple, Amritsar",
    "description": "The Harmandir Sahib, or Golden Temple, is the holiest shrine of Sikhism. Its gold-plated exterior, marble structures, and serene surrounding water body offer spiritual solace. Devotees participate in prayers, community meals, and religious ceremonies. The temple embodies Sikh traditions of equality, service, and devotion, attracting pilgrims and tourists from around the world."
  },
  {
    "title": "Konark Sun Temple, Odisha",
    "description": "The 13th-century Sun Temple at Konark is a UNESCO World Heritage Site known for its chariot-shaped design and intricate stone carvings depicting deities, dancers, and animals. Dedicated to the Sun God, it is a masterpiece of Kalinga architecture. Visitors admire the temple’s artistic grandeur, historical significance, and the coastal scenery of Odisha."
  },
  {
    "title": "Leh-Ladakh, Jammu & Kashmir",
    "description": "Leh-Ladakh is a high-altitude region known for its stunning landscapes, including barren mountains, rivers, lakes, and monasteries. Popular destinations include Pangong Lake, Nubra Valley, and Thiksey Monastery. The region attracts adventure enthusiasts for trekking, river rafting, and biking while offering spiritual and cultural experiences in a remote Himalayan setting."
  },
  {
    "title": "Ajanta and Ellora Caves, Maharashtra",
    "description": "The Ajanta and Ellora Caves are UNESCO World Heritage Sites famous for ancient rock-cut Buddhist, Hindu, and Jain temples and monasteries. They feature exquisite carvings, sculptures, and murals depicting religious narratives. Visitors explore these archaeological treasures to witness India’s early artistic and spiritual traditions in a serene natural environment."
  },
  {
    "title": "Sundarbans, West Bengal",
    "description": "The Sundarbans is the largest mangrove forest in the world, famous for the Royal Bengal Tiger and diverse wildlife. Visitors can explore the waterways via boat safaris, observe unique flora and fauna, and learn about local communities. This UNESCO World Heritage Site is vital for biodiversity conservation and offers a rare glimpse into India’s coastal ecosystems."
  }
],



"services": [
  {
    "name": "Pan India Taxi Service",
    "description": "Pan India Taxi Service provides seamless nationwide cab connectivity across major cities, towns, and highways, offering reliable travel for business, tourism, and personal trips. With a wide fleet and professional drivers, customers can enjoy comfortable, safe, and timely travel throughout the country without any hassle."
  },
  {
    "name": "All India Cab Booking",
    "description": "All India Cab Booking enables customers to book cabs anywhere in India for one-way, round-trip, multi-city, or long-distance travel. The service offers easy online booking, competitive fares, and well-maintained cabs, making it ideal for intercity journeys across different states."
  },
  {
    "name": "India Tour Cab Service",
    "description": "India Tour Cab Service offers dedicated tourist-friendly cab packages for heritage tours, pilgrimage routes, hill stations, beaches, wildlife tours, and cultural circuits across India. Expert drivers and comfortable vehicles ensure a smooth and memorable travel experience."
  },
  {
    "name": "Outstation Pan India Cab",
    "description": "Outstation Pan India Cab provides long-distance travel solutions for travellers who wish to explore multiple cities, visit relatives, or attend business meetings. The service is available 24×7 with transparent pricing, reliable vehicles, and trained chauffeurs for cross-state travel."
  },
  {
    "name": "All India Travel Taxi",
    "description": "All India Travel Taxi ensures uninterrupted travel across states with AC cabs, experienced drivers, and doorstep pickup. It is designed for vacations, business trips, road tours, and long-distance journeys across India’s major cities and tourist destinations."
  },
  {
    "name": "Interstate Cab Booking",
    "description": "Interstate Cab Booking helps passengers book cabs for travel between any two states in India, offering safe, legal, and well-regulated interstate transportation. It includes toll management, border permits, and express highway travel for a comfortable journey."
  },
  {
    "name": "One India Cab Network",
    "description": "One India Cab Network connects passengers to a nationwide fleet of verified taxis. This unified cab network ensures consistent service quality, standardized fares, and quick availability across metros, tier-2, and tier-3 cities throughout India."
  },
  {
    "name": "Affordable Pan India Taxi",
    "description": "Affordable Pan India Taxi provides cost-effective long-distance travel options with budget-friendly sedans, SUVs, and multi-seater vehicles. Customers enjoy economical fares without compromising safety, comfort, or reliability during long road journeys."
  },
  {
    "name": "Long-Distance Cabs India",
    "description": "Long-Distance Cabs India specializes in extended road trips across states, offering comfortable vehicles equipped for highway travel. This service is ideal for multi-hour and multi-day journeys with professional drivers and 24×7 support."
  },
  {
    "name": "India Tourist Cab Booking",
    "description": "India Tourist Cab Booking offers tailor-made travel packages for sightseeing, religious tours, nature tours, historical circuits, and adventure destinations. The service ensures knowledgeable drivers, clean vehicles, and customizable itineraries for tourists."
  },
  {
    "name": "Pan India Chauffeur Car",
    "description": "Pan India Chauffeur Car provides premium chauffeur-driven vehicles for business executives, VIPs, families, and tourists. Professional drivers, luxurious seating, and reliable service make it suitable for multi-city business travel and long highway trips."
  },
  {
    "name": "Safe India Cab Travel",
    "description": "Safe India Cab Travel prioritizes security with trained drivers, verified vehicles, GPS tracking, and sanitized cabs. It is ideal for families, solo travellers, senior citizens, and women ensuring a safe journey across all regions of India."
  },
  {
    "name": "North India Cab",
    "description": "North India Cab offers specialized travel routes covering Delhi, Punjab, Haryana, Rajasthan, Uttarakhand, Uttar Pradesh, Himachal Pradesh, and Jammu. The service includes pilgrimage routes, hill stations, deserts, and heritage circuits with expert local drivers."
  },
  {
    "name": "South India Cab Service",
    "description": "South India Cab Service connects major cities like Bengaluru, Chennai, Hyderabad, Kochi, Coimbatore, and more. It offers smooth intercity and tourist travel across temples, beaches, hill stations, and forests with comfortable and well-maintained vehicles."
  },
  {
    "name": "West India Taxi Service",
    "description": "West India Taxi Service covers Maharashtra, Gujarat, Goa, and Rajasthan, offering long-distance cabs for business travel, beach tours, heritage visits, and hill station trips. The service ensures safe driving through highways and diverse terrains in western India."
  },
  {
    "name": "East India Taxi Booking",
    "description": "East India Taxi Booking provides cab services across West Bengal, Odisha, Bihar, Jharkhand, and North-East regions. With experienced local drivers, customers get smooth travel through cities, rural routes, forests, and hilly terrains in eastern India."
  },
  {
    "name": "Multi-State Cab Booking",
    "description": "Multi-State Cab Booking lets passengers book long routes covering multiple states in one trip. Perfect for business tours, relocation travel, spiritual yatras, and cross-country road trips, this service ensures comfort and reliability with expert drivers."
  }
],

"tableData": [
  ["Pan India Taxi Service", "All India Cab Booking"],
  ["India Tour Cab Service", "Outstation Pan India Cab"],
  ["All India Travel Taxi", "Interstate Cab Booking"],
  ["One India Cab Network", "Affordable Pan India Taxi"],
  ["Long-Distance Cabs India", "India Tourist Cab Booking"],
  ["Pan India Chauffeur Car", "Safe India Cab Travel"],
  ["North India Cab", "South India Cab Service"],
  ["West India Taxi Service", "East India Taxi Booking"],
  ["Multi-State Cab Booking", "—"]
],


"whychoose": [
  {
    "WhyChooseheading": "Explore Pan India Cab Booking Services with Shambhu Cabs",
    "WhyChoosedescription": "Shambhu Cabs offers reliable Pan India cab booking services, making long-distance travel, business trips, and multi-city journeys comfortable and hassle-free."
  },
  {
    "WhyChooseheading": "Wide Network of Well-Maintained Vehicles",
    "WhyChoosedescription": "Choose from a variety of clean, air-conditioned, and regularly serviced vehicles available across India for all your travel needs."
  },
  {
    "WhyChooseheading": "Experienced Drivers Skilled in Long Routes",
    "WhyChoosedescription": "Our professional drivers are experienced in interstate travel, ensuring safe, timely, and smooth journeys anywhere in India."
  },
  {
    "WhyChooseheading": "Transparent Nationwide Pricing",
    "WhyChoosedescription": "Enjoy clear and upfront pricing with no hidden charges—fuel, tolls, and driver allowances included for Pan India cab services."
  },
  {
    "WhyChooseheading": "24/7 Customer Support Across India",
    "WhyChoosedescription": "Our support team is available round the clock to assist with interstate bookings, route queries, and travel assistance."
  },
  {
    "WhyChooseheading": "Flexible Travel Plans for All India Routes",
    "WhyChoosedescription": "Choose from one-way, round-trip, or customized travel plans designed for long-distance and multi-city travel across India."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All vehicles are thoroughly cleaned and sanitized before every trip to provide a safe and hygienic travel experience across India."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Pan India Service",
    "WhyChoosedescription": "We ensure punctual pickups and uninterrupted service, making your Pan India travel smooth, comfortable, and worry-free."
  }
]



















  }

const faqData = [
  {
    question: 'Does Shambhu Cabs offer Pan India cab booking services?',
    answer: 'Yes, Shambhu Cabs provides reliable Pan India cab booking services, allowing customers to travel seamlessly across major cities and states in India.',
  },
  {
    question: 'How can I book Pan India cab services with Shambhu Cabs?',
    answer: 'You can book easily through our website, mobile app, or by contacting our 24x7 customer support team for quick and hassle-free nationwide bookings.',
  },
  {
    question: 'What types of vehicles are available for Pan India cab bookings?',
    answer: 'Shambhu Cabs offers a wide fleet including sedans, SUVs, luxury cars, tempo travellers, and minibuses suitable for long-distance travel across India.',
  },
  {
    question: 'Are the drivers experienced for Pan India cab travel?',
    answer: 'Yes, our drivers are licensed, experienced, and trained for long-distance travel to ensure safety, professionalism, and comfort throughout your journey.',
  },
  {
    question: 'Can I choose custom pickup and drop-off locations for Pan India cab bookings?',
    answer: 'Absolutely. Shambhu Cabs allows you to select any pickup and drop-off locations across India as per your travel requirements.',
  },
  {
    question: 'Are Shambhu Cabs’ Pan India services available 24x7?',
    answer: 'Yes, our Pan India cab booking services are available 24x7 to meet your long-distance travel plans at any time.',
  },
  {
    question: 'Are safety and hygiene protocols followed for long-distance cab travel?',
    answer: 'All vehicles are sanitized regularly, and our drivers follow strict safety and hygiene protocols for your well-being throughout the Pan India journey.',
  },
  {
    question: 'What payment options are available for Pan India cab bookings?',
    answer: 'We accept UPI, digital wallets, credit/debit cards, bank transfers, and corporate account payments for all Pan India cab bookings.',
  },
  {
    question: 'Is customer support available during Pan India cab travel?',
    answer: 'Yes, Shambhu Cabs offers 24x7 customer support to assist you at every stage of your Pan India journey.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Aditya Verma',
    feedback: 'Shambhu Cabs made our Pan India travel extremely smooth. The driver was professional, and the vehicle was well-maintained throughout our long journey.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Shalini Nair',
    feedback: 'Highly satisfied with Shambhu Cabs’ Pan India cab services. Comfortable ride, timely service, and excellent customer support.',
    rating: 5,
  },
];




































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "mumbai-outstation-cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "mumbai-to-mahabaleshwar-cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "mumbai-to-goa-cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "mumbai-to-shirdi-cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "mumbai-nashik-cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "mumbai-to-kolhapur-cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "mumbai-to-pune-cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "mumbai-to-aurangabad-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "mumbai-to-bhimashankar-cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "mumbai-to-ashtavinayak-cab-service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "mumbai-to-5-jyotirlinga-cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "mumbai-to-lonavala-cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "mumbai-to-konkan-darshan-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "mumbai-to-alibaug-cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "mumbai-to-ahmednagar-cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "mumbai-to-matheran-cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon / Dhule Cab", link: "mumbai-to-jalgaon-dhule-cab" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "mumbai-to-lavasa-cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "mumbai-to-panchgani-cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "mumbai-to-khandala-taxi-fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "mumbai-to-surat-cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "mumbai-to-ahmedabad-cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "mumbai-to-narmada-parikrama-cab-booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Vadodara Cab", link: "mumbai-to-vadodara-cab" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "mumbai-to-daman-taxi" },
  ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pan India Cab Booking Services",
  "image": "https://www.shambhucab.com/assets/images/pan-india-cab.jpg",
  "description": "Shambhu Cabs offers Pan India cab booking services across India. Book cabs for outstation trips, long-distance travel, tourist trips, and multi-state travel. Affordable, safe, and reliable chauffeur-driven and taxi services throughout India.",
  "brand": {
    "@type": "Brand",
    "name": "Shambhu Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "980",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2000",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shambhucab.com/pan-india-cab-booking"
  }
};



  return (
    <div>

<Helmet>
  <title>Pan India Cab Booking | Explore India with Shambhu Cabs</title>

  <meta
    name="description"
    content="Book Pan India cabs with Shambhu Cabs for outstation trips, interstate travel, and long-distance journeys. Safe, reliable, and affordable taxi services across India."
  />

  <meta
    name="keywords"
    content="Pan India Taxi Service, All India Cab Booking, India Tour Cab Service, Outstation Pan India Cab, All India Travel Taxi, Interstate Cab Booking, One India Cab Network, Affordable Pan India Taxi, Long-Distance Cabs India, India Tourist Cab Booking, Pan India Chauffeur Car, Safe India Cab Travel, North India Cab, South India Cab Service, West India Taxi Service, East India Taxi Booking, Multi-State Cab Booking"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      <section className="gauto-breadcromb-area section_70">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="breadcromb-box">
                <h3> {cardData.keyword}</h3>
              </div>
            </div>
          </div>
        </div>
      </section>







      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/52.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

            

              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shambhu Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shambhu Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919819399797" className="pc-call">+91 9819399797</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919819399797"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919819399797" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shambhucab.com" className="pc-email">
                      booking@shambhucab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shambhu Cabs</strong><br />
                      Saket Tata Power CHS, Swami Samarth Marg,
                      Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                      Maharashtra India - 400703
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Exploreindiapancab;